export enum HeadsUpOperationKind {
  Idle = "idle",
  Hydrate = "hydrate",
  Generate = "generate",
  Refresh = "refresh",
  Regenerate = "regenerate",
  Live = "live",
}

export const isBlockingContextOperation = (
  operation: HeadsUpOperationKind | undefined
): operation is Exclude<
  HeadsUpOperationKind,
  HeadsUpOperationKind.Idle | HeadsUpOperationKind.Live
> => {
  return Boolean(
    operation && operation !== HeadsUpOperationKind.Idle && operation !== HeadsUpOperationKind.Live
  );
};
